import type { Subscription } from '../types/subscription';

function getUpdatedSubscriptionList(
  updatedSubscription: Subscription,
  previousSubscriptionList: Subscription[]
): Subscription[] {
  return previousSubscriptionList.map((subscription) =>
    subscription.id === updatedSubscription.id ? updatedSubscription : subscription
  );
}

export default getUpdatedSubscriptionList;
